// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"db3e927e","454":"4afa837e","702":"ff5a5201"}[chunkId] + ".chunk.js";
};